import { Dispatch, SetStateAction } from "react";
import { Tooltip, Whisper } from "rsuite";

import DotsOptionsMenu from "../../../../components/Menus/DotsOptionsMenu";
import { FileInterface } from "../../../../types/RecordInterfaces";
import { isoStringToFormat } from "../../../../utils/DateUtils";
import Constants from "../../../../utils/Constants";
import ImageCardOptions from "./ImageCardOptions";

export interface ImageCardViewProps {
  fetchedFile: FileInterface & { URL: string };
  contact: any;
  handleSelect: () => void;
  isSelected: boolean;
  onClick: () => void;
  infoClick: () => void;
  deleteClick: () => void;
  setFileToTranslate:
    | Dispatch<SetStateAction<FileInterface | null>>
    | undefined;
  onTranscribe: (setTranscribing: Dispatch<SetStateAction<boolean>>) => void;
}

const ImageCardGrid = ({
  onClick,
  infoClick,
  deleteClick,
  fetchedFile,
  setFileToTranslate,
  contact,
  isSelected,
  handleSelect,
  onTranscribe,
}: ImageCardViewProps) => {
  return (
    <div
      style={{
        background: "var(--body-background, #FFF)",
      }}
      onClick={(e) => {
        e.stopPropagation();
        handleSelect();
      }}
      className={`tw:max-w-sm tw:min-h-12 tw:flex tw:flex-col tw:pb-1 tw:p-2 tw:shadow-[0px_2px_8px_rgba(0,0,0,0.15)] tw:rounded-md tw:w-52.5 tw:h-45
          ${isSelected ? "bg-primary-selected tw:text-dark" : ""}`}
    >
      <div className="tw:flex tw:justify-between tw:w-full">
        <div className="tw:flex tw:items-center">
          <Whisper
            trigger="hover"
            speaker={
              <Tooltip>
                <span style={{ fontSize: "10px" }}>
                  {fetchedFile.Caption || ""}
                </span>
                {!!fetchedFile.Caption && <br />}
                <span style={{ fontSize: "10px" }}>
                  {`Uploaded by ${
                    contact?._RecordName || "(No Name)"
                  }, ${isoStringToFormat(
                    fetchedFile?.UploadedDate,
                    Constants.FIELDTYPES.DATE_TIME || "--"
                  )}`}
                </span>
              </Tooltip>
            }
          >
            <i className="mdi mdi-information-slab-circle-outline tw:cursor-pointer"></i>
          </Whisper>
        </div>
        <DotsOptionsMenu
          options={
            <ImageCardOptions
              deleteFile={deleteClick}
              openInfo={infoClick}
              file={fetchedFile}
              onTranslate={
                setFileToTranslate
                  ? () => setFileToTranslate(fetchedFile)
                  : undefined
              }
              onTranscribe={onTranscribe}
            />
          }
          dotsSize={20}
        />
      </div>
      {fetchedFile?.Type?.startsWith("image") ? (
        <div
          style={{ width: "190px", height: "110px" }}
          className="tw:text-center tw:m-0 tw:p-0"
        >
          <img
            className="tw:cursor-pointer tw:rounded-sm fit-image"
            src={fetchedFile.URL}
            alt=""
          />
        </div>
      ) : (
        <i
          style={{ width: 190, height: 110, fontSize: 90 }}
          className="mdi mdi-file-document-outline tw:border tw:border-lighter tw:rounded-sm tw:flex tw:justify-center tw:items-center tw:cursor-pointer"
        />
      )}
      <p
        className="tw:mx-1 tw:my-1 tw:truncate tw:text-dark tw:text-sm tw:font-medium tw:hover:underline tw:hover:text-primary tw:transition-colors cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        {fetchedFile.Name}
      </p>
    </div>
  );
};

export default ImageCardGrid;
